import { byId } from './util';

const initialState = {
  byId: {},
  componentTypes: {
    byId: {}
  }
};

export function components(state = initialState, action) {
  switch (action.type) {
  case 'COMPONENT_RECEIVE':
    return byId(state, action.payload);
  case 'COMPONENT_TYPES_RECEIVE':
    return Object.assign({}, state, {
      componentTypes: Object.assign({}, state.componentTypes, {
        byId: Object.assign({}, state.componentTypes.byId, action.payload)
      })
    });
  default:
    return state;
  }
}
